export const BrowserEventElementId = 'nudge-manager-events';

export enum Event {
  MayNudgeShow = 'may-nudge-show',
  MayNudgeShowResult = 'may-nudge-show-result',
  SetModalState = 'set-modal-state'
}
